module.exports = __webpack_public_path__ + "img/cart-empty-error.24ad2af3.svg";